<template>
    <dashboard-layout>
        <v-container fluid class="down-top-padding py-0">
            <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
            ></BaseBreadcrumb>
            <v-row dense>
                <v-col cols="12">
                    <table-customer-orders-operator></table-customer-orders-operator>
                </v-col>
            </v-row>
        </v-container>
    </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import TableCustomerOrdersOperator from './TableGrids/TableCustomerOrdersOperator.vue'

export default {
    name: 'CustomerOrdersOperator',
    props: {
        bpid: Number,
        bpopid: Number,
    },
    components: {
        DashboardLayout,
        BaseBreadcrumb,
        TableCustomerOrdersOperator,
    },
    data() {
        return {
            page: {
                title: "Customer Orders",
            },
            breadcrumbs: [
                { text: "Customer Orders", disabled: true },
            ],
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {

    }
}
</script>

<style>

</style>
